import React from "react";
import { List } from "../modules/Subscription/Management";

export function SubscribersListPage() {
  return <List />;
}
